import { render, staticRenderFns } from "./AgentTablePage.vue?vue&type=template&id=6356d7c9"
import script from "./AgentTablePage.vue?vue&type=script&lang=js"
export * from "./AgentTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports